import type { Monitor as MonitorState } from "epsm-api-types/models";

export const DEFAULT_STATE: MonitorState = {
	userId: "",
	itemName: "",
	fields: [
		"ticker",
		"adj_close_price_line_15d",
		"rt_price",
		"rt_price_chg.d1",
		"rt_price_chg.d5",
		"rt_price_chg.d20",
		"market_cap",
		"em_score",
		"pe_ttm_ratio",
		"days_to_cover_quantity",
		"powerday_trend_status",
	],
	tickers: [
		"AAPL",
		"IBM",
		"NVDA",
		"MSFT",
		"GOOGL",
		"AMZN",
		"TSM",
		"AVGO",
		"TSLA",
		"JPM",
		"V",
		"MA",
		"SHEL",
		"COST",
	],
	sort: [
		{
			name: "ticker",
			order: 1,
		},
	],
};
